/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_S3_SentInputs */

const en_funnel_ob_welcome_s3_sent = /** @type {(inputs: Funnel_Ob_Welcome_S3_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your ears keep up far faster than your eyes.`)
};

const es_funnel_ob_welcome_s3_sent = /** @type {(inputs: Funnel_Ob_Welcome_S3_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus oídos avanzan mucho más rápido que tus ojos.`)
};

/**
* | output |
* | --- |
* | "Your ears keep up far faster than your eyes." |
*
* @param {Funnel_Ob_Welcome_S3_SentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_s3_sent = /** @type {((inputs?: Funnel_Ob_Welcome_S3_SentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_S3_SentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_s3_sent(inputs)
	return en_funnel_ob_welcome_s3_sent(inputs)
});